import { render, staticRenderFns } from "./resource_item_dialog.vue?vue&type=template&id=74c3cb53"
import script from "./resource_item_dialog.vue?vue&type=script&lang=js"
export * from "./resource_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./resource_item_dialog.vue?vue&type=style&index=0&id=74c3cb53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports